import React, { useState, useEffect, useMemo } from "react";
import { filterOutVoidItems } from "src/utils/filterVoidItems";
import { getTimeInMinutes } from "src/utils/timeInMinutes";
import { fNumber } from "src/utils/formatNumber";
import { shouldShowReceiptStaffInfo,shouldShowReceiptOrderType } from "src/utils/posLayout/receiptOrderInfoUtils";
export const KitchenReceiptThroughIPAutoStation = ({
  name,
  assignee,
  customer,
  cartType,
  tableNumber,
  user,
  venueAllUser,
  tables,
  posCart,
  receiptList,
  selectedCategories,
  tableID
}) => {
  const { venue } = user ?? {}
  const { decimalPoints, configurations } = venue ?? {}
  const fontFamily= "Arial, sans-serif"
  const { isTakeawayAvailableInPos , isDailyTokenShowOnReceipt = false } = configurations ?? {}
  const { categories } = selectedCategories ?? {};
  const cartData = posCart

  let defaultReceipt = receiptList?.find((receipt) => receipt.default === true);

  // const matchedItemsByCategory = useMemo(() => {
  //   if (!cartData?.items || cartData?.items.length === 0) return [];

  //   if (openDefault) {
  //     if (!defaultReceipt) return [];
  //     return cartData?.items?.filter((item) =>
  //       defaultReceipt?.categories?.includes(item?.categoryId)
  //     );
  //   }

  //   if (categories?.length > 0) {
  //     return cartData?.items?.filter((item) =>
  //       categories?.includes(item?.categoryId)
  //     );
  //   }
  //   else {
  //     if (!defaultReceipt) return [];
  //     return cartData?.items?.filter((item) =>
  //       defaultReceipt?.categories?.includes(item?.categoryId)
  //     );
  //   }
  // }, [cartData?.items, receiptList, selectedCategories, openDefault, defaultReceipt]);

  const showReceiptStaffInfo = shouldShowReceiptStaffInfo({ cartData, user, configurations: user?.venue?.configurations });
  const showReceiptOrderType = shouldShowReceiptOrderType({ user, configurations: user?.venue?.configurations, });

  const matchedItemsByCategory = useMemo(() => {
    if (!cartData?.items || cartData.items.length === 0) return [];

    if (categories?.length > 0) {
      return cartData?.items?.filter((item) =>
        categories.includes(item?.categoryId)
      );
    }

    return cartData.items;
  }, [cartData?.items, categories]);

  const [currentTime, setCurrentTime] = useState(new Date());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const getLastSixDigits = (id) => {
    if (id) {
      return id.slice(-6);
    }
    return "";
  };

  const rider = venueAllUser?.find((user) => user.id === cartData?.rider);
  const assigneeUser = useMemo(() => {
    if (!venueAllUser?.length) return null;

    const id = assignee || cartData?.assignee?.id;

    return venueAllUser.find(
      (u) => u.id?.toString() === id?.toString()
    );
  }, [assignee, cartData, venueAllUser]);

  const getDisplayCartType = (type) => {
    switch (type) {
      case "dineIn":
        return "Dine In";
      case "takeAway":
        return "Takeaway";
      case "delivery":
        return "Delivery";
      case "pickUp":
        return "PickUp";
      case "QrDineIn":
        return "QR Dine In";
      case "QrPickUp":
        return "QR PickUp";
      case "carHop":
        return "Carhop QR";
      case "storeDelivery":
        return "S Delivery";
      case "storePickUp":
        return "S PickUp";
      default:
        return "-";
    }
  };

  const displayTableNumber = () => {
    if (tableNumber) {
      return ` (${tableNumber})`;
    }
    if (
      ((cartType === "dineIn" ||
        cartData?.cartType === "dineIn" ||
        cartData?.orderType === "dineIn" ||
        cartData?.orderType === "QrDineIn") &&
        cartData?.tableNumber) ||
      cartData?.tableId?.name
    ) {
      return ` (${cartData.tableNumber || cartData?.tableId?.name})`;
    }
    if (
      (cartData?.tableId || tableID) &&
      (cartType === "dineIn" ||
        cartData?.cartType === "dineIn" ||
        cartData?.orderType === "dineIn" ||
        cartData?.orderType === "QrDineIn")
    ) {
      let table = tables?.find((t) => t?.id == (cartData?.tableId || tableID));
      return ` (${table?.name})`;
    }
    return "";
  };

  const renderItemsTable = (items, title) => {
    if (items.length === 0) return null;

    return (
      <>
        <table
          style={{ width: "100%", borderCollapse: "collapse", marginTop: 8 }}
        >
          <thead>
            <tr>
              <th
                style={{
                  borderBottom: "1px solid black",
                  textAlign: "left",
                  fontSize: "16px",
                }}
              >
                {title}
              </th>
              <th
                style={{
                  borderBottom: "1px solid black",
                  textAlign: "left",
                  fontSize: "16px",
                }}
              >
                Qty
              </th>
            </tr>
          </thead>
          <tbody>
            {items?.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: "2px solid #000000",
                    padding: "10px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {item?.name}
                  {item.selectedVariant && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start", // MUI justifyContent="left"
                        marginTop: "8px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          fontFamily: fontFamily,
                        }}
                      >
                        Variant: {item.selectedVariant.name}
                      </div>
                    </div>
                  )}
                  {item?.groups &&
                    item?.groups.map((group) => (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          color: "#000000",
                        }}
                        key={group.id}
                      >
                        {/* Plus sign row */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: "8px", // mt={1} ≈ 8px
                          }}
                        >
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: "black", // text.primary default to black
                              fontFamily: fontFamily,
                            }}
                          >
                            +
                          </div>
                        </div>

                        {/* Map over group items */}
                        {group?.items?.map((option, idx) => (
                          <div
                            key={option.id}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                              marginTop: "8px", // mt={1}
                            }}
                          >
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "black", // text.primary default
                                fontFamily: fontFamily,
                              }}
                            >
                              <span
                                style={{
                                  marginLeft: "3px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  fontFamily: fontFamily,
                                }}
                              >
                                {Number(option.selectedQuantity || 1) > 1
                                  ? `${Number(option.selectedQuantity || 1)}x `
                                  : ""}
                                {option?.item}
                                {idx !== group?.items?.length - 1 && ", "}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  {item.notes && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#000000",
                          fontFamily: fontFamily,
                        }}
                      >
                        *{item.notes}
                      </div>
                    </div>
                  )}
                </td>
                <td
                  style={{
                    border: "2px solid #000000",
                    padding: "10px",
                    fontSize: "14px",
                  }}
                >
                  {fNumber(item?.qty, decimalPoints)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  };

  return (
    <div
      style={{
        padding: "20px", // p={2.5} ≈ 2.5 * 8px = 20px
        color: "#000000",
        fontFamily: fontFamily,
      }}
    >
      <h4
        style={{
          textAlign: "center",
          fontSize: "24px",
          marginTop: "5px",
          fontFamily: fontFamily,
          marginBottom: "16px",
        }}
      >
        Kitchen Slip (
        {categories?.length > 0
          ? selectedCategories?.name
          : defaultReceipt?.name
          ? defaultReceipt?.name
          : ""}
        )
      </h4>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            fontFamily: fontFamily,
            // marginBottom: "16px" // gutterBottom equivalent
          }}
        >
          Bill #
          <span style={{ fontWeight: "bold" }}>{cartData?.billNumber}</span>
        </p>
        {cartData?.type === "foodPanda" && <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginBottom: "3px",
            fontFamily: fontFamily,
          }}
        >
          <span style={{ fontWeight: "bold", fontFamily: fontFamily }}>
            Food Panda
          </span>
        </p>
        }
        {showReceiptOrderType && (<p
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            fontFamily: fontFamily,
            // margin: 0
          }}
        >
          {cartType
            ? getDisplayCartType(cartType)
            : cartData?.cartType
            ? getDisplayCartType(cartData?.cartType)
            : cartData?.reservationId || cartData?.cartType === "dineIn"
            ? getDisplayCartType("dineIn")
            : cartData?.orderType
            ? getDisplayCartType(cartData?.orderType)
            : "Takeaway"}
          {displayTableNumber()}
        </p>)}
      </div>

      {cartData?.receiptCount?.kitchenReceiptCount >= 1 && (
        <h3
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "20px",
            marginTop: "4px",
            fontFamily: fontFamily,
          }}
        >
          Duplicate Slip
        </h3>
      )}
      {isDailyTokenShowOnReceipt && (
        <h3
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "20px",
            marginTop: "4px",
            fontFamily: fontFamily,
          }}
        >
          {cartData?.dailyTokenNumber}
        </h3>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // marginTop: "3px",
        }}
      >
        <p
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            fontFamily: fontFamily,
            margin: 0,
          }}
        >
          Date: {new Date().toLocaleDateString()}
        </p>

        <p
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            fontFamily: fontFamily,
            margin: 0,
          }}
        >
          Time:{" "}
          {currentTime?.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "3px",
        }}
      >
        <div>
          {name !== "" ? (
            <p
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: fontFamily,
                margin: 0,
              }}
            >
              Ref: {name ? name : ""}
            </p>
          ) : (
            <p
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: fontFamily,
                margin: 0,
              }}
            >
              Ref: {cartData?.label ? cartData?.label : ""}
            </p>
          )}
        </div>
        {showReceiptStaffInfo && (<div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: fontFamily,
              margin: 0,
            }}
          >
            Staff:
            {assigneeUser
              ? ` ${assigneeUser?.firstName} ${assigneeUser?.lastName}`
              : ` ${user?.firstName} ${user?.lastName}`}
          </p>
        </div>)}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "3px",
        }}
      >
        <div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: fontFamily,
              margin: 0,
            }}
          >
            Customer:{" "}
            {customer?.firstName
              ? `${customer?.firstName} ${customer?.lastName}`
              : cartData?.customer?.firstName
              ? `${cartData?.customer?.firstName} ${cartData?.customer?.lastName}` ||
                `${cartData?.customer?.name}`
              : "-"}
            {/* {customer
              ? customer
              : cartData?.customer
                ? `${cartData.customer.firstName} ${cartData.customer.lastName}`
                : "-"} */}
            {/* Customer : {cartData?.customer?.name} */}
          </p>
        </div>
        <div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: fontFamily,
              margin: 0,
            }}
          >
            Order Id : {getLastSixDigits(cartData?.id)}
          </p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "3px",
        }}
      >
        <div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Arial, sans-serif",
              margin: 0,
            }}
          >
            Phone:{" "}
            <span className="receipt-phone-lemon-font"
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {customer?.cusPhone
                ? `0${customer?.cusPhone}`
                : customer?.phone
                  ? `0${customer?.phone}`
                  : cartData?.customer?.cusPhone
                    ? `0${cartData?.customer?.cusPhone}`
                    : cartData?.customer?.phone
                      ? `0${cartData?.customer?.phone}`
                      : "-"}
            </span>
          </p>
        </div>
      </div>

      {(rider || cartData?.rider) &&
        (cartData?.cartType === "delivery" ||
          cartData?.orderType === "delivery") && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
            }}
          >
            <div>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: fontFamily,
                  margin: 0,
                }}
              >
                Rider:
                {rider
                  ? ` ${rider?.firstName} ${rider.lastName}`
                  : cartData?.rider
                  ? ` ${cartData?.rider.firstName} ${cartData?.rider.lastName}`
                  : "-"}
              </p>
            </div>
          </div>
        )}

      {(cartData?.cartType === "carHop" ||
        cartData?.orderType === "carHop") && (
        <>
          <div
            style={{
              borderBottom: "1px solid black",
              marginTop: "5px",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              // marginTop: "-10px",
            }}
          >
            <p
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: fontFamily,
                margin: 0,
              }}
            >
              Car #{cartData?.customer?.carNumber}
            </p>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: fontFamily,
                margin: 0,
              }}
            >
              Color : {cartData?.customer?.carColor}
            </p>
          </div>

          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: fontFamily,
              margin: 0,
            }}
          >
            Notes : {cartData?.customer?.notes}
          </p>
        </>
      )}

      <div style={{ borderBottom: "2px solid black", marginTop: "5px" }} />

      <>
        {(() => {
          const items = matchedItemsByCategory || [];
          const groupedTimes = [...(cartData?.groupedItemsTime || [])];
          const itemGroupNos = [
            ...new Set(items.map((item) => item.groupItemNo)),
          ];
          const timeGroupNos = groupedTimes.map((g) => g.groupNo);

          itemGroupNos.forEach((groupNo) => {
            if (!timeGroupNos.includes(groupNo)) {
              groupedTimes.push({
                groupNo,
                groupTime: new Date().toISOString(),
                _id: `${groupNo}-${Date.now()}`,
              });
            }
          });

          groupedTimes.sort((a, b) => a.groupNo - b.groupNo);
          return groupedTimes.map((elem) => {
            const groupItems = filterOutVoidItems(items).filter(
              (item) => item.groupItemNo === elem.groupNo
            );

            if (groupItems.length === 0) return null;

            const kitchenItems = groupItems.filter(
              (item) => item.isKitchenItem
            );
            const nonKitchenItems = groupItems.filter(
              (item) => !item.isKitchenItem
            );

            return (
              <div key={elem._id} style={{ margin: "16px 8px 0px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      margin: 0,
                    }}
                  >
                    {new Date(elem.groupTime).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      margin: 0,
                      marginLeft: "8px", // replaces MUI ml={1}
                    }}
                  >
                    ({getTimeInMinutes(elem?.groupTime, currentTime)} mins ago)
                  </p>
                </div>

                {kitchenItems.length > 0 &&
                  renderItemsTable(kitchenItems, "Kitchen Items")}
                {nonKitchenItems.length > 0 &&
                  renderItemsTable(nonKitchenItems, "Non-Kitchen Items")}
              </div>
            );
          });
        })()}
      </>
      <div
        style={{
          fontSize: "14px",
          textAlign: "center",
          marginTop: "12px", // mt: 2 (~8px)
          fontFamily: fontFamily,
        }}
      >
        Print Time: {new Date().toLocaleDateString()}{" "}
        {currentTime?.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </div>
    </div>
  );
};
